import isPlainObject from "lodash/fp/isPlainObject";
function isMergeableObject(value) {
  return isPlainObject(value) && !value.$$typeof;
}
export { isMergeableObject as default };